import React from "react";

const SettingsSecondaryText = ({ children }) => {
  return <p className="settings-secondary-text">{children}</p>;
};

export default SettingsSecondaryText;
